import React from 'react';
import Select from 'react-select';

export default function RSSelect({ options = [], value, onChange, placeholder = '', isClearable = false, emptyValue = '', width = 180, optionHeight = 28, visible = 6, isMulti = false }) {
  const OPTION_HEIGHT = optionHeight;
  const VISIBLE_OPTIONS = visible;
  const MENU_MAX_HEIGHT = OPTION_HEIGHT * VISIBLE_OPTIONS;

  const opts = options.map(o => (o && typeof o === 'object' && o.value !== undefined) ? o : { value: o, label: String(o) });

  let selected = null;
  if (isMulti) {
    if (Array.isArray(value)) selected = opts.filter(o => value.map(String).includes(String(o.value))); else selected = [];
  } else {
    selected = opts.find(o => String(o.value) === String(value)) || null;
  }

  const compactStyles = {
    control: base => ({ ...base, minHeight: 32, height: 32, fontSize: 13, borderRadius: 6, padding: '0 6px', width: width, maxWidth: '100%' }),
    valueContainer: base => ({ ...base, padding: '0 6px', height: 32 }),
    indicatorsContainer: base => ({ ...base, height: 32 }),
    input: base => ({ ...base, margin: 0, padding: 0 }),
    singleValue: base => ({ ...base, margin: 0 }),
    placeholder: base => ({ ...base, margin: 0, color: '#666', fontSize: 13 }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: base => ({ ...base, minWidth: width, width: width }),
    menuList: base => ({ ...base, maxHeight: MENU_MAX_HEIGHT, overflowY: 'auto' }),
    option: base => ({ ...base, fontSize: 13, padding: '4px 8px', minHeight: OPTION_HEIGHT, display: 'flex', alignItems: 'center' })
  };

  const menuPortalTarget = (typeof document !== 'undefined') ? document.body : undefined;

  return (
    <Select
      options={opts}
      value={selected}
      onChange={opt => {
        if (isMulti) {
          if (!opt) return onChange([]);
          return onChange(opt.map(o => o.value));
        }
        return onChange(opt ? opt.value : emptyValue);
      }}
      isClearable={isClearable}
      placeholder={placeholder}
      menuPortalTarget={menuPortalTarget}
      menuPosition={'fixed'}
      menuMaxHeight={MENU_MAX_HEIGHT}
      styles={compactStyles}
      components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
      classNamePrefix="rs"
      isMulti={isMulti}
    />
  );
}
